import { gql } from '@apollo/client';

export const CREATE_CHARGING_SESSION_MUTATION = gql`
  mutation CreateChargingSessionV3($input: CreateChargingSessionInputV3!) {
    createChargingSessionV3(input: $input) {
      chargingSessionId
      startTime
      endTime
      status
      licensePlate
      parkingZoneUid
      transactionId
      priceInCents
      energyInWatts
      cardId
      countryCode
      stationId
      evseId
    }
  }
`;
